const philosophyColors = {
  PHILOSOPHY_50: '#E0F3F2',
  PHILOSOPHY_100: '#B3E1DD',
  PHILOSOPHY_200: '#81CEC8',
  PHILOSOPHY_600: '#008E81',
}

export default philosophyColors
